/**
 * Created by Gayratjon Rayimjonov on 5/24/2017.
 */
(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsActiveUserOS', StatsActiveUserOS);

    StatsActiveUserOS.$inject = ['$resource', 'DateUtils'];

    function StatsActiveUserOS ($resource, DateUtils) {
        var resourceUrl =  'api/stats-active-os';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        // data = angular.fromJson(data);
                        // data.registrationDate = DateUtils.convertDateTimeFromServer(data.registrationDate);
                    }
                    return data;
                }
            }
        });
    }
})();
